import React from 'react';
import { DataTable as DamcoTable, InPageDialog } from 'damco-components';
import { formatDate, formatValueIfNullOrUndefined, timeToMs, isFeatureEnabled } from 'utilities/util';
import { RouteComponentProps, withRouter } from 'react-router';
import { status_text } from './constants';
import * as validation from 'constants/validationMessages';
import * as util from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { fetchExceptions } from 'actions/exception-management';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

interface ExceptionManagementProps {
	data: any;
	pageCount: number;
	cols: any[];
	calculateAging: boolean;
	hasUpdateAction?: boolean;
	tableName?: string;
	handleDownload?: (data: any, type?: string) => void;
	handleUpdate?: (data: any) => void;
	linkAction: (data: any) => void;
	fetchData: (data: any) => void;
	handleDetails: (data: any, title?: string) => void;
	sendReprocess(id: string): void;
	toggleReprocess(id: string): void;
}
interface IState {
	data: any[];
	showDialog: boolean;
	isClosed: boolean,
	message: string,
	retryCount: number,
}

interface IMapStateToProps {
	featureToggles: IFeatureToggleModel[];
	exceptions: any;
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
	featureToggles: state.featureToggle.featureToggles,
	exceptions: state.exceptions.exceptions
});

interface IMapDispatch {
	fetchExceptions: (pageNumber: number, pageSize: number) => Promise<void>;
}

const ExceptionManagement: string = '.exception-management';

interface IProps extends IMapDispatch, IMapStateToProps, RouteComponentProps, ExceptionManagementProps { }
export class _ErrorTable extends React.Component<IProps, IState> {
	public dataTable = React.createRef<any>();
	public tableBody = React.createRef<any>();
	public myTableWrap: any = null;
	public unlisten: any;
	public state = {
		data: [],
		showDialog: false,
		message: '',
		isClosed: false,
		retryCount: 0,
	};
	public componentDidMount() {
		this.myTableWrap = document.querySelector(ExceptionManagement);
		this.checkRedirect();
		this.unlisten = this.props.history.listen((location, action) => {
			this.checkRedirect();
		});
		if (this.props.data && this.props.data.length > 0) {
			this.initData();
		}
	}
	public componentWillUnmount() {
		this.unlisten = null;
	}
	public componentDidUpdate = (prevProps: any, prevState: any) => {
		if (prevProps.data !== this.props.data) {
			this.initData();
			this.setState({
				showDialog: false
			});
		}
		if (prevState.isClosed !== this.state.isClosed) {
			const t: any = this.dataTable && this.dataTable.current;
			t.hideContextRibbon();
		}
		if (!this.myTableWrap) {
			this.myTableWrap = document.querySelector(ExceptionManagement);
		}
		if (this.myTableWrap) {
			const htmlEl = this.myTableWrap.querySelectorAll('.rt-tbody .rt-tr-group');
			if (htmlEl && htmlEl.length > 0) {
				// tslint:disable-next-line: prefer-for-of
				let totalrows: any;
				totalrows = htmlEl.length > this.props.data ? this.props.data : htmlEl.length;
				for (let i = 0; i < totalrows; i++) {
					if (htmlEl[i] && htmlEl[i].parentElement) {
						htmlEl[i].classList.remove('-selected');
						if (htmlEl[i].querySelector('input') && !htmlEl[i].querySelector('input').hasAttribute('listenerOnClick')) {
							htmlEl[i].querySelector('input').addEventListener('click', (e: any) => {
								this.handleResetReprocessButtonVisibility(i);
							});
							htmlEl[i].querySelector('input').setAttribute('listenerOnClick', 'true');
						}
					}
				}
			}
			return htmlEl;
		}
	};
	public handleResetReprocessButtonVisibility(i: number) {
		const selectedData: any = this.dataTable;
		if (isFeatureEnabled(FEATURE_TOGGLES.FINOPS_RESET_ERROR_LOG_REPROCESS, this.props.featureToggles) && this.props.data[i].reprocess === false) {
			this.dataTable.current.props.actions.parentContextualActions = [
				{ isMoreBtn: false, label: 'Reprocess', action: () => { this.openEventLogsDetailsModal(selectedData, 'reprocess'); } },
				{ isMoreBtn: false, label: 'Reset Reprocess', action: () => { this.openEventLogsDetailsModal(selectedData, 'resetReprocess'); } },

			];
		} else {
			this.dataTable.current.props.actions.parentContextualActions = [
				{ isMoreBtn: false, label: 'Reprocess', action: () => { this.openEventLogsDetailsModal(selectedData, 'reprocess'); } },
			];
		}
	}
	public checkReprocess = (id: string) => {
		const target: any = this.props.data.filter((el: any) => el.historyLogId === id);
		if (target && target[0] && target[0].reprocess) {
			this.props.sendReprocess(id);
		} else {
			this.setState({
				showDialog: true,
				message: validation.ExceptionManagement.Error_no_reprocess
			});
		}
	};
	public checkRedirect = () => {
		const list: any = location.href;
		const errorList = this.tableBody.current;
		// tslint:disable-next-line: forin
		if (list && list.length > 0 && errorList) {
			if (list.indexOf('closed') > -1) {
				errorList.classList.value = 'closed';
				this.setState({ isClosed: true });
			} else {
				errorList.classList.value = '';
				this.setState({ isClosed: false });
			}
		}
	};
	public render() {
		return (<>
			<InPageDialog
				showDialog={this.state.showDialog}
				type={'error'}
				message={this.state.message}
				closeMethod={() => this.setState({ showDialog: false, message: '' })} />
			<div ref={this.tableBody} id="exception-management">
				<DamcoTable
					id={`exception-management-${Math.random()}`}
					data={this.state.data}
					columns={this.props.cols}
					isEditable={false}
					isExpandable={false}
					isSelectable={this.props.calculateAging ? !this.state.isClosed : false}
					selectedOption={'single'}
					isSortable={true}
					isResizable={true}
					hasFooter={false}
					showColumnOptions={true}
					manualPagination={true}
					pageCount={this.props.pageCount}
					ref={this.dataTable}
					tableName={this.props.tableName ? this.props.tableName : 'exception-management'}
					showPagination={true}
					linkAction={(data: any) => this.openEventLogsDetailsModal(data ? data : '', 'link')}
					fetchData={(data: any) => {
						if (data && data.sorted.length > 0) {
							if (this.dataTable && this.dataTable.current && this.dataTable.current.hideContextRibbon) {
								this.dataTable.current.hideContextRibbon();
							}
						}
						if (this.props.fetchData) {
							this.props.fetchData(data);
						}
					}}
					defaultPageSize={10}
					actions={{
						parentContextualActions: this.getActions(),
					}}
				/>
			</div>
		</>
		);
	}
	public getActions = () => {
		const selectedData: any = this.dataTable;
		let actions = [
			{ isMoreBtn: false, label: 'Reprocess', action: () => { this.openEventLogsDetailsModal(selectedData, 'reprocess'); } },
		];
		if (this.props.hasUpdateAction && this.props.handleUpdate && actions.length === 1) {
			actions = [{
				isMoreBtn: false, label: 'Close Notification', action: () => {
					if (this.props.handleUpdate) {
						this.props.handleUpdate(selectedData);
						setTimeout(() => {
							selectedData.state.selected = [];
						}, 1000);
					}
				}
			}];
		}
		return actions;
	};
	public openEventLogsDetailsModal = (tableSelected: any, target: string) => {
		if (tableSelected && tableSelected.message) {
			const data = tableSelected.message ? [tableSelected.message] : '';
			this.props.handleDetails(data);
		} else {
			if (target === 'resetReprocess' && tableSelected.current && tableSelected.current.getSelectedItems()) {
				const selected = tableSelected.current.getSelectedItems();
				this.props.toggleReprocess(selected[0].historyLogId);
				const t: any = this.dataTable && this.dataTable.current;
				t.hideContextRibbon();
				this.props.fetchExceptions(this.props.exceptions.page, this.props.exceptions.pageSize);
			}
			else if (this.dataTable && target === 'reprocess' && tableSelected.current && tableSelected.current.getSelectedItems()) {
				const selected = tableSelected.current.getSelectedItems();
				this.checkReprocess(selected[0].historyLogId);
				const t: any = this.dataTable && this.dataTable.current;
				t.hideContextRibbon();
			} else if (this.props.tableName === 'exception-management-file-download') {
				this.props.linkAction(tableSelected.requestId);
			} else {
				const id = tableSelected.historyLogId || tableSelected.logId || tableSelected.notificationId || tableSelected.id;
				this.props.linkAction(id);
			}
		}
	};
	public initData = () => {
		const getData = (data: string) => {
			const resp = JSON.parse(data);
			const arr: string[] = [];
			if (resp.length > 0) {
				resp.forEach((e: any) => arr.push(`${e.Key} - ${e.Value}`));
			}
			return arr;
		};
		let newData = util.formatData(this.props.data);
		if (this.props.calculateAging) {
			newData = this.props.data.map((obj: any, index: number) => ({
				...obj,
				id: obj.id ? obj.id : index + 1,
				itemType: obj.itemType ? obj.itemType.toUpperCase() : '',
				reprocess: obj.reprocess ? 'Yes' : 'No',
				createTime: formatDate(obj.createTime),
				lastUpdated: formatDate(obj.lastUpdated),
				errorDetails: <button className="link" onClick={() => this.props.handleDetails(getData(obj.errorDetails))} dangerouslySetInnerHTML={{ __html: 'View error' }} />,
				aging: obj.status.toLowerCase() === 'completed' ?
					<span dangerouslySetInnerHTML={this.checkStatus(obj.aging)} /> :
					<span dangerouslySetInnerHTML={this.checkStatus(obj.aging)} />,
				messageDetails: 'View message'
			}));
		} else if (this.props.tableName === 'exception-management-file-download') {
			newData = this.props.data.map((obj: any, index: number) => {
				return {
					...obj,
					id: obj.id ? obj.id : index + 1,
					errorLogURl: obj.errorLogURl !== '-' ? 'Details' : '-',
					fileName: obj.status === 'Failed' ? obj.fileName : <button className="link" onClick={() => {
						if (this.props.handleDownload) {
							this.props.handleDownload(obj.requestId);
						}
					}
					} dangerouslySetInnerHTML={{ __html: `${obj.fileName}` }} />,
				};
			});
		} else {
			newData = this.props.data.map((obj: any, index: number) => {
				return {
					...obj,
					id: obj.id ? obj.id : index + 1,
					description: formatValueIfNullOrUndefined(obj.description),
					destination: formatValueIfNullOrUndefined(obj.destination),
					timestamp: formatDate(obj.timestamp),
					messageDetails: 'View message',
					errorLogURl: obj.errorLogURl !== '-' ? 'Details' : '-',
					downloadOutputFile: obj.outputFileURL && obj.outputFileURL !== '-' ? <button className="link" onClick={() => {
						if (this.props.handleDownload) {
							this.props.handleDownload(obj.id);
						}
					}
					} dangerouslySetInnerHTML={{ __html: `Download Output File` }} /> : '-',
					pendingReason: obj.pendingReason && obj.pendingReason !== '-'
						? <button className="link" onClick={() => this.props.handleDetails([obj.pendingReason], 'Pending Reason')} dangerouslySetInnerHTML={{ __html: 'View reason' }} />
						: null,
				};
			});
		}
		this.setState({
			data: newData
		});
	};
	public checkStatus = (val: string) => {
		let status: any = '';
		if (timeToMs(val) >= 28800000 && timeToMs(val) <= 86400000) {
			// 8 to 24h
			status = status_text.positive;
		} else if (timeToMs(val) > 86400000 && timeToMs(val) <= 115200000) {
			// 24h - 32h
			status = status_text.warning;
		} else if (timeToMs(val) > 115200000) {
			// 32h up
			status = status_text.negative;
		}
		return { __html: `${status} ${val}` };
	};
}
const mapDispatch = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatch => ({
	fetchExceptions: (pageNumber: number, pageSize: number) => dispatch(fetchExceptions(pageNumber, pageSize)),
});
export const ErrorTable = withRouter(connect<IMapStateToProps, IMapDispatch, {}, IStore>(mapStateToProps, mapDispatch)(_ErrorTable));